module.exports = __webpack_public_path__ + "static/media/pending_customs_clearance.f6102d8c.png";